import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React                                         from 'react'
import { useTranslation }                            from 'react-i18next'
import PropTypes                                     from 'prop-types'

const ShortFormSelect = (props) => {

  const { t } = useTranslation()
  const { name, title, handleChange, value, inputProps, items, allowAllOption = true, ...otherProps } = props

  return <FormControl variant="standard" fullWidth>
    <InputLabel htmlFor={`control-${name}`}>{title}</InputLabel>
    <Select
      id={`control-${name}`}
      value={value}
      onChange={handleChange(name)}
      labelId={`label-${name}`}
      label={title}
      {...otherProps}
    >
      {allowAllOption && <MenuItem key={'item-not-set'} value={''}>{t('Not set')}</MenuItem>}
      { items.map(it => (<MenuItem key={`item-${it.id}`} value={it.id}>{it.name}</MenuItem>)) }
    </Select>
  </FormControl>
}

ShortFormSelect.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
}

export default ShortFormSelect